module.exports = __webpack_public_path__ + "img/L3.ba94e3ef.svg";